var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
/**
 * Fetches a detailed array of datatypes available on this galaxy instance.
 * Does not cache the result or use a store.
 */
export function useDetailedDatatypes() {
    const datatypesLoading = ref(true);
    const datatypes = ref([]);
    function getDatatypes() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const datatypesPromise = GalaxyApi().GET("/api/datatypes", {
                    params: { query: { extension_only: false } },
                });
                const datatypeEDAMFormatsPromise = GalaxyApi().GET("/api/datatypes/edam_formats/detailed");
                const datatypeEDAMDataPromise = GalaxyApi().GET("/api/datatypes/edam_data/detailed");
                const [{ data: baseData, error: baseError }, { data: datatypeEDAMFormats, error: edamFormatsError }, { data: datatypeEDAMData, error: edamDataError },] = yield Promise.all([datatypesPromise, datatypeEDAMFormatsPromise, datatypeEDAMDataPromise]);
                const error = baseError || edamFormatsError || edamDataError;
                if (error) {
                    rethrowSimple(error);
                }
                const items = baseData;
                // We can safely use non-null assertions here because otherwise we would have thrown an error
                datatypes.value = items.map((type) => {
                    var _a, _b;
                    const typeEDAMFormat = (_a = datatypeEDAMFormats[type.extension]) !== null && _a !== void 0 ? _a : null;
                    const typeEDAMData = (_b = datatypeEDAMData[type.extension]) !== null && _b !== void 0 ? _b : null;
                    return {
                        extension: type.extension,
                        description: type.description,
                        descriptionUrl: type.description_url,
                        edamFormat: typeEDAMFormat === null || typeEDAMFormat === void 0 ? void 0 : typeEDAMFormat.prefix_IRI,
                        edamFormatLabel: typeEDAMFormat === null || typeEDAMFormat === void 0 ? void 0 : typeEDAMFormat.label,
                        edamFormatDefinition: typeEDAMFormat === null || typeEDAMFormat === void 0 ? void 0 : typeEDAMFormat.definition,
                        edamData: typeEDAMData === null || typeEDAMData === void 0 ? void 0 : typeEDAMData.prefix_IRI,
                        edamDataLabel: typeEDAMData === null || typeEDAMData === void 0 ? void 0 : typeEDAMData.label,
                        edamDataDefinition: typeEDAMData === null || typeEDAMData === void 0 ? void 0 : typeEDAMData.definition,
                    };
                });
            }
            catch (e) {
                console.error("unable to fetch available datatypes\n", e);
            }
            finally {
                datatypesLoading.value = false;
            }
        });
    }
    getDatatypes();
    return { datatypes, datatypesLoading };
}
